import React, { useMemo, useState } from "react";
import classNames from "classnames";
import { update_form_data } from "../../../Redux/features/OrderSection/OrderSectionSlice";
import { useAppDispatch, useAppSelector } from "../../../Redux/app/hooks";
import OrderSearch from "../../../assets/search.svg"; // Assuming same icon as used in OptionsForm
import socket from "../../../socket";
import {
  fetchChartData,
  update_futOptionChart
} from "../../../Redux/features/ChartData/ChartDataSlice";

type Props = {
  contracts: any[];
  setConValue: any;
  onClose: any;
  iex_symbol?: string;
};

const FutureForm = ({ iex_symbol = "", contracts = [], setConValue, onClose }: Props) => {
  const dispatch = useAppDispatch();
  const formData = useAppSelector((state) => state.orderSection.form_data);
  const errMSG = useAppSelector((state) => state.dashBoard.fut_opt_errMsg);
  const [searchText, setSearchText] = useState("");

  const filteredContracts = useMemo(() => {
    return contracts.filter((contract) => contract.DisplaySecurity?.toLowerCase().includes(searchText.toLowerCase()));
  }, [contracts, searchText]);

  const handleSelectFuture = (contract: any) => {
    console.log(contract, "contractSet");
    var securitySet = {
      security_list: [
        {
          conid: contract?.ContractId,
          currency: contract?.Currency,
          exch: contract?.Exchange,
          isin_code: contract?.DisplaySecurity,
          market_id: 3,
          security_id: contract?.ContractId,
        },
      ],
      // security_list: Number(localStorage.getItem("login-id")) === 2 ? user_securityList : client_user_securityList,
      socket_id: socket.id,
      from: "web",
      user_id: localStorage.getItem("login-id"),
    };
    //console.log("CHART::1--current_security_conid",contract?.ContractId);
    localStorage.setItem("current_security_conid", contract?.ContractId);
    socket.emit("security_subscription", securitySet);

    //Futures Chart Subscription
    let chartSocketPayload = {
      market_id: 3,
      conid: contract?.ContractId,
      security_id: contract?.ContractId,
      isin_code: contract?.DisplaySecurity,
      user_id: localStorage.getItem("login-id"),
      socket_id: socket.id,
      from: "web",
    };

    let chartPayload = {
      market_id: 3,
      security_id: 0,
      from_date: "",
      to_date: "",
      price_type: 1,
      candleTimeline: "1D",
      sec_type: "FUT",
      switch_chart_type: "Candlestick",
      conid: contract?.ContractId,
      exchange: contract?.Exchange,
      isin_code: contract?.DisplaySecurity,
      currency: contract?.Currency,
    };
    //console.log("CHART::2--fetchChartData(chartPayload)",chartPayload);
    dispatch(fetchChartData(chartPayload));
    //console.log("CHART::3--update_futOptionChart(chartPayload)",chartPayload);
    dispatch(update_futOptionChart(chartPayload))
    
    //console.log("CHART::4--handle_chart_data_subscribe",chartSocketPayload);
    socket.emit("handle_chart_data_subscribe", chartSocketPayload);
  };

  return (
    <>
      {contracts.length === 0 ? (
        <div className="text-center text-sm text-gray-500">No futures securities found.</div>
      ) : (
        <div className=" w-[480px]">
          <div className="flex flex-col gap-4">
            <div className="flex relative border rounded-xl">
              <img className="order-search h-3 m-auto pl-4" src={OrderSearch} alt="" />
              <input
                type="search"
                className="w-full placeholder:text-sm rounded-xl px-2 py-2 text-[0.78vw] outline-none"
                placeholder="Search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            <div className="overflow-x-auto order-search-list max-h-44">
              {filteredContracts.length ? (
                <>
                  <ul>
                    {filteredContracts.map((contract, index) => (
                      <li
                        key={contract.DisplaySecurity}
                        onClick={() => {
                          setConValue(contract);
                          handleSelectFuture(contract);
                          localStorage.setItem("current_market_id", "3");
                          // dispatch(update_form_data({ vendor: 2}));
                          onClose();
                        }}
                        className={classNames("border hover:bg-[#B0CCF352]", {
                          "bg-[#f0f0f0]": index % 2 !== 0,
                        })}
                      >
                        <span className="list-type equity-type"></span>
                        <div className="text-[0.75rem] leading-[1.25] text-[#a4a3a3] px-[0.6vw] py-[0.42vw] flex justify-start items-start cursor-pointer">
                          {contract.DisplaySecurity}
                        </div>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <div className="text-center text-sm text-gray-500">No futures securities found.</div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FutureForm;
